import React from 'react';
import { DragOverlay, defaultDropAnimationSideEffects } from '@dnd-kit/core';
import PropTypes from 'prop-types';

const dropAnimationConfig = {
    sideEffects: defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0.4',
            },
        },
    }),
};

export default function SortableOverlay({ children }) {
    return (
        <DragOverlay
            dropAnimation={dropAnimationConfig}
        >
            {children ? (
                <div style={{
                    backgroundColor: 'white',
                    opacity: 1,
                    position: 'fixed',
                    width: '100%',
                    height: '90%',
                    display: 'flex',
                    alignItems: 'center',
                    boxShadow: '0px 1px rgba(0,0,0,0.1)',
                }}
                >
                    <div style={{
                        backgroundColor: '#e0e0e0',
                        transform: 'scale(1)',
                        opacity: 1,
                        position: 'fixed',
                        width: '90%',
                        height: '25%',
                        display: 'flex',
                        padding: '6px',
                        alignItems: 'center',
                    }}
                    >
                        {children}
                    </div>
                </div>
            ) : null}
        </DragOverlay>
    );
}

SortableOverlay.propTypes = {
    children: PropTypes.node,
};
